<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="InventPriceTable1" :fields="fields" :title="table_title.title1" :show_query_container="true"
        :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false" :show_toolbar="true" :show_filter="true"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusy" @state_change="state_change"
        @on_query="on_query" :show_toolbar_button="[0, 0, 0, 0, 1]" @tool_invoke="tool_invoke" @on_cell_button_click="on_cell_button_click" tableref="38e9999d79cc43b7859c4d9e8a49e5e3">
        <template #query>
          物料编号：<el-input clearable size="small" style="width: 150px" v-model="ItemId" class="mr-1"></el-input>
          物料名称：<el-input clearable size="small" style="width: 180px" v-model="NameAlias"></el-input>
        </template>
        <template #toolbar>
          <el-button type="info" plain @click="createForm()" class="ml-2 iconfont icon-add-new" size="mini"> {{$t("common.new")}}
          </el-button>
        </template>
      </TableMain>
    </BaseContainer>
    <BaseModal ref="invent_price_modal" :title="invent_price_modal_title" :width="'30%'" @saveData="SaveData">
      <template #modal_content>
        <el-form ref="dataForm" label-width="150px" class="demo-dataForm" style="height: 200px">
          <span v-for="(item,index) in InventPriceTableModel" :key="index">
            <el-col :span="24">
              <el-form-item :label="item.label" v-if="item.key=='dataAreaId'">
                <el-select size="small" v-model="item.value" @change="CompanyChanged(item)" filterable clearable placeholder="请选择销售公司"
                  class="w-100">
                  <el-option v-for="(t,k) in getCompanyOptions()" :key="k" :label="t.label" :value="t.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key=='ItemId'">
                <el-select size="small" v-model="item.value" filterable remote reserve-keyword :remote-method="ItemIdRemoteMethod" clearable
                  @clear="ItemIdRemoteMethod('')" placeholder="请输入物料关键词" class="w-100">
                  <el-option v-for="(t,k) in InventOptions" :key="k" :label="t.label" :value="t.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key == 'price'">
                <el-input type="number" v-model="item.value"></el-input>
              </el-form-item>
              <el-form-item :label="item.label" v-else-if="item.key != 'id'">
                <el-input type="text" v-model="item.value" clearable></el-input>
              </el-form-item>
            </el-col>
          </span>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer";
import TableMain from "../components/table/TableMain";
import * as InventBomVersionController from "../../controllers/sd/InventBomVersionController";
import * as InventTableController from "../../controllers/base/InventTableController";
import BaseModal from "../components/modals/baseModal";

export default {
  components: {
    BaseContainer,
    TableMain,
    BaseModal
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "物料价格",
      },
      fields: _.cloneDeep(InventBomVersionController.fields.invent_price),
      ItemId: "",
      NameAlias: "",
      isBusy: false,
      cur_dataAreaId: "",
      InventPriceTableModel: [],
      InventOptions: [],
      invent_price_modal_title: ""
    };
  },
  created() {
    let unIncludsFields = ["CompanyName", "NameAlias", "ReferenceNum", "create_at", "create_by_username", "update_at", "update_by_username"]
    let fields = _.filter(this.fields, (t) => {
      if (!_.includes(unIncludsFields, t.key)) {
        return t;
      }
    })
    this.InventPriceTableModel = _.map(fields, (t) => {
      let m = {
        key: t.key,
        label: t.label,
        value: "",
        dataType: "input",
        seq: 0
      }
      return m
    })
    this.InventPriceTableModel = _.orderBy(this.InventPriceTableModel, ["seq"], ["asc"])
  },
  methods: {
    getCompanyOptions() {
      return _.map(this.$store.state.biz_data.baseData.CompanyInfo, (v) => {
        return {
          value: v.DataArea,
          label:
            v.DataArea + ":" + (v.CompanyName == null ? "" : v.CompanyName),
        };
      });
    },
    async CompanyChanged(item) {
      this.cur_dataAreaId = item.value;
      await this.getKvInvent(item.value);
    },
    async on_query(set_data, isLoading = true, id = 0) {
      if (isLoading) {
        this.isBusy = true;
        set_data([]);
      }
      this.ItemId = _.trim(this.ItemId)
      this.NameAlias = _.trim(this.NameAlias);
      let p = {};
      if (this.ItemId != "") p.ItemId = this.ItemId;
      if (this.NameAlias != "") p.NameAlias = this.NameAlias;
      if (id != 0) p.id = id;
      let _result = await InventBomVersionController.methods.getDataInventPrice(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        if (id != 0) {
          let dt = this.$refs.InventPriceTable1.my_data;
          if (dt.length > 0) {
            let m = _.find(dt, { id: _result[0][0].id });
            if (m)
              Object.assign(m, _result[0][0]);
            else
              this.$refs.InventPriceTable1.InsertItems(_result[0][0]);
            return;
          }
        }

        set_data(_.orderBy(_result[0], ["id"], ["desc"]));
      }
      this.isBusy = false;
    },
    createForm() {
      this.InventOptions = [];
      this.cur_dataAreaId = "";
      this.invent_price_modal_title = "新建物料价格";
      _.each(this.InventPriceTableModel, (t) => {
        switch (t.key) {
          default: t.value = ""
        }
      });
      this.$refs.invent_price_modal.show()
    },
    async on_cell_button_click(data) {
      this.invent_price_modal_title = "编辑BOM版本"
      for (var k in data.item) {
        let m = _.find(this.InventPriceTableModel, { key: k });
        if (m) {
          m.value = data.item[k]
        }
      }
      this.cur_dataAreaId = data.item.dataAreaId;
      await this.getKvInvent(data.item.dataAreaId, data.item.ItemId);
      this.$refs.invent_price_modal.show()
    },
    ///根据dataAreaId获取物料
    async getKvInvent(_dataAreaId, query = '') {
      let p = {};
      p.dataAreaId = _dataAreaId;
      p.Query = query;
      let _result = await InventTableController.methods.getTop100InventKvData(p);
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.InventOptions = _.map(_result[0], (t) => {
          return { value: t.ItemId, label: t.ItemId + ":" + t.NameAlias };
        });
      }
    },
    ///物料下拉
    async ItemIdRemoteMethod(query) {
      await this.getKvInvent(this.cur_dataAreaId, query);
    },
    ///保存
    async SaveData(cb) {
      //数据验证
      let msg = "", am = {};
      _.each(this.InventPriceTableModel, (t) => {
        am[t.key] = t.value;
        if (msg == "" && t.required && t.value == "") {
          msg = t.label + "不能为空！"
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info");
        cb(null);
        return;
      }

      let p = {};
      am.ItemId = _.trim(am.ItemId);
      if (am.id == "") {
        delete am.id;
        p.add = am;
        //检查价格是否存在
        let exists_dt = await InventBomVersionController.methods.getDataInventPrice({ dataAreaId: am.dataAreaId, ItemId: am.ItemId });
        if (exists_dt && exists_dt.length > 0 && exists_dt[0] && exists_dt[0].length > 0) {
          await this.$confirm('价格已存在，是否继续保存？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(() => {
            cb(false);
            return;
          });
          p.remove = exists_dt[0][0];
        }
      }
      else {
        p.edit = am;
      }

      let rt = await InventBomVersionController.methods.saveDataInventPrice(p);
      if (rt) {
        await this.on_query(this.$refs.InventPriceTable1.SetData, false, rt[0].id);
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(false);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    //#region 状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"));
      if (!ask) {
        cb(false);
        return;
      }

      let p = {};
      if (data.state == "deleted") {
        p.delete = data.selected_items;
      }
      let rt = await InventBomVersionController.methods.saveDataInventPrice(p);
      if (rt) {
        this.$refs.InventPriceTable1.RemoveItems(data.selected_items);
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true);
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        };
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data);
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data);
      }
    },
  },
};
</script>
